import { IStorage } from '../../services/storage/storage.interface';
import { isPersistableAction, PersistableAction } from '../actions/base-actions';
import { StateHelper } from '../helpers/statehelper';

export class StatePersistor {

    constructor(public storage: IStorage) {

    }

    /**
     * This function receives an Action and determine which item in the store to add/update/remove
     * @param action
     * @returns {Promise<any>}
     */
    persistAction(action: PersistableAction): Promise<any> {

        if (!isPersistableAction(action)) {
            return Promise.resolve();
        }

        const key = this.makeKey(action);

        if (!key) {
            return Promise.resolve();
        } else if (!this.isRemoveAction(action)) {
            return this.storage.set(key, action);
        } else {
            return this.storage.remove(key);
        }
    }

    makeKey(action: PersistableAction): string {
        return StateHelper.makeKey(action);
    }

    preparePayload(action: PersistableAction): any {
        return StateHelper.preparePayload(action);
    }

    isRemoveAction(action: PersistableAction): boolean {
        return StateHelper.isRemoveAction(action);
    }
}



// WEBPACK FOOTER //
// ./src/core/store/persister/statepersistor.ts